<template>
  <div v-show="isVisible">
    <div v-if="showTitle" class="field__inner-title">
      <div>{{ schema.title }}</div>
      <p v-if="schema.help">{{ schema.help || '' }}</p>
    </div>

    <v-autocomplete
      :label="schema.label || schema.title"
      v-model="localValue"
      :items="options"
      :multiple="multiple"
      :rules="rules"
      :class="{ 'background-dark': schema.dark }"
      persistent-hint
      item-text="label"
      :disabled="isDisabled"
      :hint="schema.hint"
      :search-input.sync="search"
      @change="clearSearch"
    >
      <template v-slot:selection="data">
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          close
          @click:close="unselectUser(data.item.value)"
          class="pl-1"
        >
          <user-info-circle class="mt-0" :user-id="data.item.value" />
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <div class="d-flex align-center user-list-item">
          <avatar size="micro" :img="item.photo" class="mr-2" />
          <span v-html="highlightUserName(item.label)"></span>
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import GenericField from './GenericField';
import { mapActions, mapGetters } from 'vuex';
import { highlightSearch } from '@/filters/helpers';

import Avatar from '@/components/basic/avatar/Avatar';
import UserInfoCircle from '@/views/contacts/contact/UserInfoCircle';

export default {
  name: 'UserListField',
  mixins: [GenericField],
  components: {
    Avatar,
    UserInfoCircle,
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    ...mapGetters('users', ['usersOptions']),

    multiple() {
      const value = this.schema?.multiple;
      return typeof value === 'undefined' ? true : value;
    },

    excludeUsers() {
      return this.schema?.excludeUsers || [];
    },

    options() {
      const { role } = this.schema || {};
      if (!role) return this.usersOptions;

      return this.usersOptions.filter((user) => {
        if (this.excludeUsers.includes(user.value + '')) return false;

        if (role) {
          return user.role === role;
        }

        return false;
      });
    },
  },

  methods: {
    ...mapActions('users', ['loadUsers']),
    highlightUserName(name) {
      if (!this.search) return name;
      return highlightSearch(name, this.search);
    },

    clearSearch() {
      this.search = '';
    },

    unselectUser(userId) {
      if (this.isDisabled) return;

      if (!Array.isArray(this.localValue)) {
        this.localValue = '';
        return;
      }

      this.localValue = this.localValue.filter((id) => {
        return id !== userId;
      });
    },
  },

  mounted() {
    this.loadUsers();
  },
};
</script>

<style>
.user-list-item .highlighted {
  background-color: var(--v-primary-base);
  color: #fff;
  padding: 0 2px;
}
</style>
